export default __webpack_public_path__ + "static/media/nie-default-logo.22261295.jpg";